import * as React from "react";
const NewsDelete = (props) => (
  <svg
    width={18}
    height={22}
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 0C6.12665 0 4 2.12665 4 4.75V5H0.75C0.335786 5 0 5.33579 0 5.75C0 6.16421 0.335786 6.5 0.75 6.5H16.75C17.1642 6.5 17.5 6.16421 17.5 5.75C17.5 5.33579 17.1642 5 16.75 5H13.5V4.75C13.5 2.12665 11.3734 0 8.75 0ZM8.75 1.5C10.5449 1.5 12 2.95507 12 4.75V5H5.5V4.75C5.5 2.95507 6.95507 1.5 8.75 1.5Z"
      fill="#FB064F"
    />
    <path
      d="M2.49664 7.67906C2.45746 7.2667 2.09142 6.96418 1.67906 7.00336C1.2667 7.04254 0.964183 7.40858 1.00336 7.82094C1.09783 8.81522 1.26833 10.0403 1.48748 11.6151L1.76903 13.6381C2.03819 15.5729 2.19085 16.6701 2.52109 17.569C3.1357 19.2418 4.23205 20.5828 5.64206 21.1778C6.40773 21.5009 7.28352 21.5006 8.58733 21.5H8.91267C10.2165 21.5006 11.0923 21.5009 11.8579 21.1778C13.2679 20.5828 14.3643 19.2418 14.9789 17.569C15.3092 16.6701 15.4618 15.5729 15.731 13.6381L16.0125 11.6151C16.2317 10.0403 16.4022 8.81522 16.4966 7.82094C16.5358 7.40858 16.2333 7.04254 15.8209 7.00336C15.4086 6.96418 15.0425 7.2667 15.0034 7.67906C14.9123 8.63702 14.7465 9.83003 14.5244 11.4261L14.262 13.3111C13.9715 15.3988 13.8384 16.3236 13.5709 17.0517C13.055 18.4558 12.1972 19.4066 11.2748 19.7958C10.8246 19.9858 10.2792 20 8.75 20C7.22083 20 6.67544 19.9858 6.22524 19.7958C5.30279 19.4066 4.44496 18.4558 3.92907 17.0517C3.66156 16.3236 3.52851 15.3988 3.23798 13.3111L2.97564 11.4261C2.75352 9.83003 2.58766 8.63703 2.49664 7.67906Z"
      fill="#FB064F"
    />
  </svg>
);
export default NewsDelete;
